import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="flex min-h-[calc(100svh-2rem)] bg-brand-main px-4 py-5 text-center sm:py-6" data-id="element-84" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-85" data-mp="23wcxdyn0k2jv">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-teal sm:text-xs" data-id="element-86" data-mp="2wm33pliem05f">
          EL PACK DOCENTE COMPLETO DE CIENCIAS
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-blue sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-87" data-mp="2mt4f43mwq9lt">
          Enseña un año completo de <span className="italic text-brand-purple" data-id="element-88" data-mp="3fi1o1g58au1w">Física y Química</span> con solo 5 minutos de preparación
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-89" data-mp="3ka35rhl61czb">
          Física y Química Lista te da todo lo que necesitas para enseñar, motivar y evaluar a tus alumnos: teoría, actividades,
          laboratorios y exámenes, todo listo para usar.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/wuQYNi6GYtgTaLycxoPTar/ChatGPT_Image_5_ago_2026,_08_39_15-Photoroom.png" alt="Pack Física y Química Lista con los seis tomos y los cinco bonos" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-90" data-mp="2p6wgwgwdczqk" />
        <div className="flex w-full flex-col items-center" data-id="element-91" data-mp="3847e7vyfxj3d">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-92" data-mp="383nz0n06d8t1">
            QUIERO EL PACK FÍSICA Y QUÍMICA LISTA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-93" data-mp="1dqok6w3mcimt">
            ✓ Descarga instantánea <span className="px-1 text-brand-orange" data-id="element-94" data-mp="38tl0bf19mdto">·</span> ✓ Garantía de 7 días{' '}
            <span className="px-1 text-brand-orange" data-id="element-95" data-mp="3dseg5e40ygx0">·</span> ✓ +2.000 docentes
          </p>
        </div>
      </motion.div>
    </section>;
}